module.exports = function() {
  return new Worker(__webpack_public_path__ + "527845a3176cbf85f2da.worker.js");
};